import { QueryClient, UseQueryResult } from '@tanstack/react-query'

export function makeSuccessQueryResult<T>(
  query: UseQueryResult<T>,
  data: T
): UseQueryResult<T> {
  return {
    ...query,
    data,
    error: null,
    isError: false,
    isLoading: false,
    isPending: false,
    isLoadingError: false,
    isRefetchError: false,
    isSuccess: true,
    status: 'success',
  } as UseQueryResult<T>
}

export type RetryQuery = (failureCount: number, error: unknown) => boolean

export const automaticRetryQuery: RetryQuery = (
  failureCount: number,
  error: unknown
) => {
  return failureCount > 2 ? false : true
}

export const onManualRetry = async (client: QueryClient) => {
  try {
    await client.invalidateQueries()
  } catch (err) {
    console.error('Manual retry error: ', err)
  }
}
